import { Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto } from '@wealthlane/api-services/wealthlane-identity-service';
import { TwoFactorPurposeService } from '@wealthlane/api-services/wealthlane-identity-service';
import { type UseQueryResult, useQuery } from 'react-query';


const useGetTwoFactorPurposes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Array<Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto> | undefined, unknown> => {
  return useQuery(['getTwoFactorPurposes'], async () => {
    return await handleRequest(
      TwoFactorPurposeService.getApiIdentityApiAppTwoFactorPurpose()
    );
  });
};

export default useGetTwoFactorPurposes;
